export default {
  computed: {
    $toast() {
      return {
        success: (message) =>
          this.$bvToast.toast(message, {
            title: 'Operação Realizada',
            variant: 'success',
            autoHideDelay: 1500
          }),
        error: (message) =>
          this.$bvToast.toast(message, {
            title: 'Erro',
            variant: 'danger',
            autoHideDelay: 1500
          }),
        warning: (message) =>
          this.$bvToast.toast(message, {
            title: 'Atenção',
            variant: 'warning',
            autoHideDelay: 1500
          })
      }
    }
  }
}
